module.exports = __webpack_public_path__ + "static/img/4_v2.a92ca160.png";